import { render, staticRenderFns } from "./discount.vue?vue&type=template&id=dcbb98aa&"
import script from "./discount.vue?vue&type=script&lang=js&"
export * from "./discount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports